var Functions = Object;

import { utilities } from "@/functions/Utilities.js";
import { user } from "@/functions/User.js";
import { account } from "@/functions/Account.js";
import { organization } from "@/functions/Organization.js";
import { permissions } from "@/functions/Permissions.js";
import { subject } from "@/functions/Subject.js";
import { students } from "@/functions/Students.js";
import { unit } from "@/functions/Unit.js";
import { scoreTemplate } from "@/functions/ScoreTemplate.js";
import { score } from "@/functions/Score.js";
import { behavior } from "@/functions/Behavior.js";

Functions.install = function(Vue) {
  /*** Account ***/
  Vue.prototype.$getAccountVariables = account.getAccountVariables;
  Vue.prototype.$createAccount = account.createAccount;
  Vue.prototype.$getMyAccountsBasic = account.getMyAccountsBasic;
  Vue.prototype.$getAccount = account.getAccount;

  /*** Behavior ***/
  Vue.prototype.$getMyBehaviorSettings = behavior.getMyBehaviorSettings;
  Vue.prototype.$getMyBehaviorTrackers = behavior.getMyBehaviorTrackers;
  Vue.prototype.$createBehaviorTracker = behavior.createBehaviorTracker;
  Vue.prototype.$createBehaviorTrackerSettings =
    behavior.createBehaviorTrackerSettings;
  Vue.prototype.$createBehaviorTrackerUsersAssignments =
    behavior.createBehaviorTrackerUsersAssignments;
  Vue.prototype.$createBehaviorTrackerScore =
    behavior.createBehaviorTrackerScore;
  Vue.prototype.$createBehaviorSetting = behavior.createBehaviorSetting;
  Vue.prototype.$removeBehaviorTrackerUsersAssignments =
    behavior.removeBehaviorTrackerUsersAssignments;
  Vue.prototype.$updateBehaviorTrackerScore =
    behavior.updateBehaviorTrackerScore;
  Vue.prototype.$updateBehaviorTracker = behavior.updateBehaviorTracker;
  Vue.prototype.$archiveBehaviorTracker = behavior.archiveBehaviorTracker;
  Vue.prototype.$getBehaviorTracker = behavior.getBehaviorTracker;
  Vue.prototype.$unarchiveBehaviorTracker = behavior.unarchiveBehaviorTracker;
  Vue.prototype.$deleteBehaviorTracker = behavior.deleteBehaviorTracker;

  /*** Organization ***/
  Vue.prototype.$createOrganization = organization.createOrganization;
  Vue.prototype.$updateOrganization = organization.updateOrganization;
  Vue.prototype.$getMyOrganizations = organization.getMyOrganizations;
  Vue.prototype.$getMySimpleOrganizations =
    organization.getMySimpleOrganizations;
  Vue.prototype.$createStudentOrganizations =
    organization.createStudentOrganizations;
  Vue.prototype.$removeStudentOrganizations =
    organization.removeStudentOrganizations;
  Vue.prototype.$getPermissionOrganizations =
    organization.getPermissionOrganizations;
  Vue.prototype.$getMySubjectOrganizations =
    organization.getMySubjectOrganizations;
  Vue.prototype.$getMyArchivedSubjectOrganizations =
    organization.getMyArchivedSubjectOrganizations;

  /*** Permissions ***/
  Vue.prototype.$canSeeAllTabs = permissions.canSeeAllTabs;
  //database
  Vue.prototype.$getAllPermissions = permissions.getAllPermissions;
  Vue.prototype.$createUserPermissionsForAccount =
    permissions.createUserPermissionsForAccount;
  Vue.prototype.$createUserPermissionsForOrganizations =
    permissions.createUserPermissionsForOrganizations;
  Vue.prototype.$createNewAccountUserPermission =
    permissions.createNewAccountUserPermission;
  Vue.prototype.$createUserPermissionsForSubjects =
    permissions.createUserPermissionsForSubjects;
  Vue.prototype.$removeUserPermissions = permissions.removeUserPermissions;
  Vue.prototype.$createUserPermissionsForStudent =
    permissions.createUserPermissionsForStudent;
  Vue.prototype.$createSingleUserStudentPermission =
    permissions.createSingleUserStudentPermission;
  Vue.prototype.$createSingleUserSubjectPermission =
    permissions.createSingleUserSubjectPermission;
  Vue.prototype.$createSingleUserOrganizationPermission =
    permissions.createSingleUserOrganizationPermission;
  Vue.prototype.$checkPermissionToSeeStudent =
    permissions.checkPermissionToSeeStudent;
  //account
  Vue.prototype.$canSeeAccountSettings = permissions.canSeeAccountSettings;
  Vue.prototype.$canManageAccount = permissions.canManageAccount;
  Vue.prototype.$canViewAccount = permissions.canViewAccount;
  //organization
  Vue.prototype.$canManageOrganization = permissions.canManageOrganization;
  Vue.prototype.$canViewOrganization = permissions.canViewOrganization;
  //student
  Vue.prototype.$canViewStudent = permissions.canViewStudent;
  Vue.prototype.$canManageStudent = permissions.canManageStudent;
  //subject
  Vue.prototype.$canViewSubject = permissions.canViewSubject;
  Vue.prototype.$canManageSubject = permissions.canManageSubject;

  /*** Score ***/
  Vue.prototype.$createScore = score.createScore;
  Vue.prototype.$getStudentUnitScores = score.getStudentUnitScores;
  Vue.prototype.$updateScore = score.updateScore;
  Vue.prototype.$getScoresByStudentAndUnit = score.getScoresByStudentAndUnit;
  Vue.prototype.$deleteScore = score.deleteScore;

  /*** Score Templates ***/
  Vue.prototype.$getScoreTemplateInputTypes =
    scoreTemplate.getScoreTemplateInputTypes;
  Vue.prototype.$getScoreTemplateTypes = scoreTemplate.getScoreTemplateTypes;
  Vue.prototype.$createScoreTemplate = scoreTemplate.createScoreTemplate;
  Vue.prototype.$createScoreTemplateInputs =
    scoreTemplate.createScoreTemplateInputs;
  Vue.prototype.$getMyScoreTemplates = scoreTemplate.getMyScoreTemplates;
  Vue.prototype.$getScoreTemplateInputSummary =
    scoreTemplate.getScoreTemplateInputSummary;
  Vue.prototype.$getInputDefaultValue = scoreTemplate.getInputDefaultValue;
  Vue.prototype.$prettifyInput = scoreTemplate.prettifyInput;
  Vue.prototype.$getMyManageScoreTemplates =
    scoreTemplate.getMyManageScoreTemplates;
  Vue.prototype.$deleteScoreTemplate = scoreTemplate.deleteScoreTemplate;
  Vue.prototype.$updateScoreTemplate = scoreTemplate.updateScoreTemplate;
  Vue.prototype.$updateScoreTemplateInputs =
    scoreTemplate.updateScoreTemplateInputs;
  Vue.prototype.$getMyManageScoreTemplate =
    scoreTemplate.getMyManageScoreTemplate;

  /*** Students ***/
  Vue.prototype.$getMyStudents = students.getMyStudents;
  Vue.prototype.$getAllGrades = students.getAllGrades;
  Vue.prototype.$createStudent = students.createStudent;
  Vue.prototype.$createManageStudentPermissions =
    students.createManageStudentPermissions;
  Vue.prototype.$createViewStudentPermissions =
    students.createViewStudentPermissions;
  Vue.prototype.$createStudentSubjectPermissions =
    students.createStudentSubjectPermissions;
  Vue.prototype.$getDashboardStudents = students.getDashboardStudents;
  Vue.prototype.$getStudent = students.getStudent;
  Vue.prototype.$getDashboardStudent = students.getDashboardStudent;
  Vue.prototype.$getPermissionStudents = students.getPermissionStudents;
  Vue.prototype.$getMyStarredStudents = students.getMyStarredStudents;
  Vue.prototype.$createStarStudent = students.createStarStudent;
  Vue.prototype.$removeStarStudent = students.removeStarStudent;
  Vue.prototype.$updateStudent = students.updateStudent;
  Vue.prototype.$getStudentArchivedData = students.getStudentArchivedData;
  Vue.prototype.$getMySubjectStudents = students.getMySubjectStudents;
  Vue.prototype.$getMyArchivedSubjectStudents =
    students.getMyArchivedSubjectStudents;

  /*** Subject ***/
  Vue.prototype.$createSubject = subject.createSubject;
  Vue.prototype.$updateSubject = subject.updateSubject;
  Vue.prototype.$createStudentSubjects = subject.createStudentSubjects;
  Vue.prototype.$createStudentSubjectsPairs =
    subject.createStudentSubjectsPairs;
  Vue.prototype.$archiveStudentSubjectsPairs =
    subject.archiveStudentSubjectsPairs;
  Vue.prototype.$getMySubjects = subject.getMySubjects;
  Vue.prototype.$getPermissionSubjects = subject.getPermissionSubjects;
  Vue.prototype.$getMyStarredSubjects = subject.getMyStarredSubjects;
  Vue.prototype.$createStarSubject = subject.createStarSubject;
  Vue.prototype.$removeStarSubject = subject.removeStarSubject;
  Vue.prototype.$archiveSubject = subject.archiveSubject;
  Vue.prototype.$unarchiveSubject = subject.unarchiveSubject;
  Vue.prototype.$deleteSubject = subject.deleteSubject;

  /*** Unit ***/
  Vue.prototype.$createStudentUnits = unit.createStudentUnits;
  Vue.prototype.$createUnit = unit.createUnit;
  Vue.prototype.$createUnitStudents = unit.createUnitStudents;
  Vue.prototype.$createStudentUnitsPairs = unit.createStudentUnitsPairs;
  Vue.prototype.$archiveStudentUnitsPairs = unit.archiveStudentUnitsPairs;
  Vue.prototype.$updateUnit = unit.updateUnit;
  Vue.prototype.$unarchiveStudentUnits = unit.unarchiveStudentUnits;
  Vue.prototype.$deleteStudentUnits = unit.deleteStudentUnits;
  Vue.prototype.$archiveUnit = unit.archiveUnit;
  Vue.prototype.$unarchiveUnit = unit.unarchiveUnit;
  Vue.prototype.$deleteUnit = unit.deleteUnit;

  /*** User ***/
  Vue.prototype.$updateLastLogin = user.updateLastLogin;
  Vue.prototype.$createNewUser = user.createNewUser;
  Vue.prototype.$loadUser = user.loadUser;
  Vue.prototype.$createUserOrganization = user.createUserOrganization;
  Vue.prototype.$updateUser = user.updateUser;
  Vue.prototype.$signUpNewUser = user.signUpNewUser;
  Vue.prototype.$emailNewUser = user.emailNewUser;
  Vue.prototype.$confirmNewUser = user.confirmNewUser;
  Vue.prototype.$queryUsers = user.queryUsers;
  Vue.prototype.$getUserByEmail = user.getUserByEmail;

  /*** Utilities ***/
  Vue.prototype.$uuidv4 = utilities.uuidv4;
  Vue.prototype.$showSnackbar = utilities.showSnackbar;
  Vue.prototype.$getStates = utilities.getStates;
  Vue.prototype.$updateToggleIcon = utilities.updateToggleIcon;
  Vue.prototype.$orderByName = utilities.orderByName;
  Vue.prototype.$orderByParseName = utilities.orderByParseName;
  Vue.prototype.$orderByTitle = utilities.orderByTitle;
  Vue.prototype.$orderByOrder = utilities.orderByOrder;
  Vue.prototype.$orderByParseOrder = utilities.orderByParseOrder;
  Vue.prototype.$orderByLastName = utilities.orderByLastName;
  Vue.prototype.$dateToYYYYMMDD = utilities.dateToYYYYMMDD;
  Vue.prototype.$orderByUnitTitle = utilities.orderByUnitTitle;
  Vue.prototype.$rangeArray = utilities.rangeArray;
  Vue.prototype.$tryParse = utilities.tryParse;
  Vue.prototype.$orderByDate = utilities.orderByDate;
  Vue.prototype.$onlyUnique = utilities.onlyUnique;
  Vue.prototype.$showTooltip = utilities.showTooltip;
  Vue.prototype.$hideTooltip = utilities.hideTooltip;
  Vue.prototype.$onlyUniqueStudentIds = utilities.onlyUniqueStudentIds;
};

export { Functions };
